

				@if(isProcessingNotifications){
					<div>
						<div style="display:flex;justify-content:center;width:100%;margin:8px 0;margin-bottom:10px;margin-top:10px;">
							<mat-progress-bar mode="determinate" [value]="sendProgressValue" style="width:80vw;"></mat-progress-bar>
						</div>
						<div style="display:flex;justify-content:center;width:100%;text-align:center;margin-bottom:30px;">
							<span style="font-size:18px;font-weight:bold;">Sending Notification to {{currentNotificationName}} for invoice {{currentNotificationInvoiceNumber}}</span>
						</div>
					</div>
					
				}

				@if(isLoadingData){
					<div>
						<div style="display:flex;justify-content:center;width:100%;margin:8px 0;margin-bottom:10px;margin-top:10px;">
							<mat-progress-bar mode="indeterminate"  style="width:80vw;"></mat-progress-bar>
						</div>
						<div style="display:flex;justify-content:center;width:100%;text-align:center;margin-bottom:30px;">
							<span style="font-size:18px;font-weight:bold;">Loading Data...</span>
						</div>
					</div>
					
				}


@if (!isLoadingData && (quickSearchResults?.length ?? 0) > 0 && noSenderEmailAddress === false) {
<div style="display:flex;justify-content:center;width:100%;padding-left:30px;padding-right:30px;box-sizing:border-box;">
<div style="width:100%;"><strong> Invoices Found: {{quickSearchResults.length}} / Selected to Email: {{selectedToEmail}} / Emails Sent: {{emailedCount}}</strong></div>
</div>
<div style="display:flex;justify-content:center;width:100%;padding-left:30px;padding-right:30px;box-sizing:border-box;">
<igx-grid [data]="quickSearchResults" [width]="'100%'" [height]="'550px'" [autoGenerate]="false" style="margin-top: 10px;">
	<igx-column field="selectedForSend" header="" [sortable]="false" [filterable]="false" [resizable]="false" [width]="'135px'">
		<ng-template igxHeader>
			<button mat-stroked-button style="min-width:0;padding:0 8px;line-height:28px;" (click)="selectAllToEmail()" [disabled]="isSendingEmails">All</button>
			<button mat-stroked-button style="min-width:0;padding:0 8px;line-height:28px;margin-left:6px;" (click)="clearAllToEmail()" [disabled]="isSendingEmails">None</button>
		</ng-template>
		<ng-template igxCell let-cell="cell">
			@if(cell.row.data.notificationStatus === 'success') {
				<span class="material-icons" style="font-size:18px;line-height:18px;color:green;">done</span>
			}
			@else if(cell.row.data.notificationStatus === 'error') {
				<span class="material-icons" style="font-size:18px;line-height:18px;color:red;">error</span>
			}
			@else {
				<mat-checkbox
					[ngModel]="cell.row.data.selectedForSend"
					(ngModelChange)="onSelectedForSendChange(cell.row.data, $event)"
					(click)="$event.stopPropagation()"
					[disabled]="isSendingEmails"
					aria-label="Select invoice"
				></mat-checkbox>
			}
		</ng-template>
	</igx-column>

	<igx-column field="invoiceDate" header="Rev Date" dataType="date" [width]="'115px'">
		<ng-template igxCell let-cell="cell">
			{{ cell.value | date:'M-d-yyyy' }}
		</ng-template>
	</igx-column>
	<igx-column field="invoiceNumber" header="Invoice No." [width]="'175px'">
		<ng-template igxCell let-cell="cell">
			<a href="" (click)="onDisplayInvoice(cell.row.data.invoiceNumber, cell.row.data.lotNumber, cell.row.data.entityId); $event.preventDefault()" style="color:#1976d2;text-decoration:underline;cursor:pointer;">
				{{cell.value}}
			</a>
		</ng-template>
	</igx-column>
	<igx-column field="originalBalance" header="Amount" dataType="number">
		<ng-template igxCell let-cell="cell">
			{{ cell.value | currency:'USD':'symbol':'1.2-2' }}
		</ng-template>
	</igx-column>
	<igx-column field="customerName" header="Parker"></igx-column>
	<igx-column field="companyName" header="Company"></igx-column>
	<igx-column field="emailAddress" header="Email Address" [width]="'225px'"></igx-column>
	<igx-column field="delivery" header="Delivery"  [width]="'100px'"></igx-column>
	<igx-column field="created" header="Created" dataType="date"  [width]="'115px'">
		<ng-template igxCell let-cell="cell">
			{{ cell.value | date:'M-d-yyyy' }}
		</ng-template>
	</igx-column>
	<igx-column field="dueDate" header="Due Date" dataType="date"  [width]="'115px'">
		<ng-template igxCell let-cell="cell">
			{{ cell.value | date:'M-d-yyyy' }}
		</ng-template>
	</igx-column>
	<igx-column field="dateSent" header="Date Sent" dataType="date"  [width]="'115px'">
		<ng-template igxCell let-cell="cell">
			{{ cell.value | date:'M-d-yyyy' }}
		</ng-template>
	</igx-column>
	<igx-column field="currentBalance" header="Balance" dataType="number">
		<ng-template igxCell let-cell="cell">
			{{ cell.value | currency:'USD':'symbol':'1.2-2' }}
		</ng-template>
	</igx-column>
	<igx-column field="IsPortal" header="Is Portal" dataType="boolean" [width]="'115px'">
		<ng-template igxCell let-cell="cell">
			{{ cell.value === true || cell.value === 'true' || cell.value === 1 ? 'Y' : 'N' }}
		</ng-template>
	</igx-column>
</igx-grid>
</div>


<div style="display:flex;justify-content:center;margin-top:16px;">
	<mat-form-field appearance="outline" style="width:600px;">
		<mat-label>Add Comments to Email Message</mat-label>
		<textarea
			matInput
			id="invoiceComments"
			name="invoiceComments"
			[(ngModel)]="invoiceUserComments"
			style="height:400px;"
		></textarea>
	</mat-form-field>
</div>


<div style="display:flex;justify-content:center;width:100%;margin-top:10px;">
	<button class="btn btn-primary mt-3 ace-blue" style="width:200px;" (click)="onSendInvoices()" [disabled]="selectedRows <= 0 || isSendingEmails">
		Send Invoices
	</button>
</div>
} @else if (!isLoadingData && hasCompletedSearch) {
<div style="margin-top:100px;margin-left:30px;">
	<span style="font-size:18px;font-weight:bold;">No invoices found matching this Lot Number and Search Criteria.</span>
</div>
} @else if (!isLoadingData) {
<div style="margin-top:100px;margin-left:30px;">
	<span style="font-size:18px;font-weight:bold;">Search to find invoices to send...</span>
</div>
}